const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    background: "#fff"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/styles.js